import { UDV_PLANS } from './constants'

/**
 * @typedef {{
 *   id: string,
 *   label: string,
 *   token: string,
 *   plan: 'demo'|'lite'|'pro'|'premium',
 *   defaultShell?: 'classic'|'edge'|'studio'|'ohif'|'oviyamng'|null,
 *   enabled: boolean,
 * }} PlatformToken
 */

/**
 * Registry embebido en el build (production solo usa esto).
 * Rotar tokens antes de clientes reales.
 *
 * @type {PlatformToken[]}
 */
export const TOKENS_DEFAULTS = [
  {
    id: 'plat-premium',
    label: 'Plataforma Premium',
    token: 'udv-plat-premium-9e8d7c6b5a40',
    plan: UDV_PLANS.PREMIUM,
    defaultShell: 'studio',
    enabled: true,
  },
  {
    id: 'plat-pro',
    label: 'Plataforma Pro',
    token: 'udv-plat-pro-7f3a9c2e1b84',
    plan: UDV_PLANS.PRO,
    defaultShell: 'studio',
    enabled: true,
  },
  {
    id: 'plat-lite',
    label: 'Plataforma Lite',
    token: 'udv-plat-lite-4d8e2a91c0f6',
    plan: UDV_PLANS.LITE,
    defaultShell: 'edge',
    enabled: true,
  },
  {
    id: 'plat-demo',
    label: 'Plan Demo',
    token: 'udv-plat-demo-a1b2c3d4e5f6',
    plan: UDV_PLANS.DEMO,
    defaultShell: 'classic',
    enabled: true,
  },
]
